import { create } from "zustand";
import { persist } from "zustand/middleware";

type ImpersonatedMember = {
  id: string;
  name: string;
  email: string;
  picture?: string | null;
};

type ImpersonationState = {
  member: ImpersonatedMember | null;
};

type ImpersonationActions = {
  setMember: (member: ImpersonatedMember | null) => void;
  clear: () => void;
};

// When set, the client sends an `x-act-as-user` header so an org admin operates
// on this member's data (resumes, jobs, applications, AI). See axios.ts.
export const useImpersonationStore = create<ImpersonationState & ImpersonationActions>()(
  persist(
    (set) => ({
      member: null,
      setMember: (member) => {
        set({ member });
      },
      clear: () => {
        set({ member: null });
      },
    }),
    { name: "impersonation" },
  ),
);
